import React from 'react';
import { Select, Typography } from 'antd';
export const FrequencySelector = ({ value, onChange, disabled, hideLabel }) => {
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 1 } },
        !hideLabel && (React.createElement(Typography.Text, { type: "secondary", style: { whiteSpace: 'nowrap' } }, "Order frequency")),
        React.createElement(Select, { value: value, disabled: disabled, onChange: val => onChange?.(val), "aria-label": "order-frequency", style: { width: '100%' }, options: [
                { label: 'One-time', value: 'one-time' },
                { label: 'Monthly', value: 'monthly' },
                { label: 'Quarterly', value: 'quarterly' },
                { label: 'Yearly', value: 'yearly' },
            ] })));
};
export const ORDER_FREQUENCY_ONE_TIME = 'one-time';
export function frequencyImpliesBatchShipment(freq) {
    return !!freq && freq !== ORDER_FREQUENCY_ONE_TIME;
}
